import { Helmet } from "react-helmet"
import { useEffect } from 'react'
import { Link, useLocation } from "react-router-dom"
import scrollSmoothTo from "../../components/Functionals/Smooth"
// import { PhoneLink } from "../../components/Shared/Links"
// import PDF__Link from '../../PDF__NAME.pdf'
import slideBg from '../../assets/images/family-bg.jpg'
import rating from '../../assets/images/rating.png'
import slideFam from '../../assets/images/family-meal-slide.jpg'
import slideWine from '../../assets/images/slide-marchWine.jpg'
// import togoPickup from '../../assets/images/takeout-pickup.png'
import togoEat from '../../assets/images/takeout-eatBeach.png'
import pizza from '../../assets/images/pizza.jpg'
import pizzaL from '../../assets/images/pizzaLong.jpg'
import { caterLink, tteatLink, dashLink } from "../../components/Shared/Links"

export default function Home() {
  const location = useLocation()

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1)) // Remove the '#' from hash
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [location])

  return (
    <div className="pageStyles homepage">
      <Helmet>
        <meta name="description" content="Villaggio Grille is one of the Alabama Gulf Coast's best restaurants. Italian fusion at its tastiest, Villaggio wants to prove that they live up to their reputation. Join us for lunch or dinner, and leave satisfied." />
      </Helmet>

      <div className="homeSlide">
        <div className="uk-position-relative uk-visible-toggle home-slideshow" tabIndex="-1" uk-slideshow="animation: fade; autoplay:true;">
          <ul className="uk-slideshow-items">
            <li><Link to="/pairing"><img src={slideWine} alt="Villaggio's Upcoming Wine Pairing" /></Link></li>
            <li className="reviewSlide">
              <img src={slideBg} alt="Villaggio Grille bar and dining room background" />
              <div className="uk-position-center uk-position-small uk-text-center uk-light rs-box">
                <div className="rs-bg">
                  <img src={rating} alt="Villaggio Grille 5 star review" className="icon" />
                  <p className="auth">Alex Whitaker</p>
                  <p className="rs-intro">
                    "Each piece of shrimp, scallop and crab were cooked to perfection, not under or overdone in the slightest. And 
                    though not listed on the menu, the fresh basil in the sauce worked wonderfully in concert with the other 
                    flavors<span className="no-sm">, bringing a light refreshment to match the heavier richness of the alfredo.</span>
                    <span className="only-sm">...</span>"
                  </p>
                  <button className="vg-btn" type="button" uk-toggle="target: #full-review">Read Full Review</button>
                </div>
              </div>
            </li>
            <li>
              <button onClick={() => scrollSmoothTo("family-meals")} title="Family Meals Menu" className="smoothBtn">
              <img src={slideFam} alt="Takeout Family Meals in Orange Beach, Al" />
            </button></li>
          </ul>

          <div className="uk-light">
            <button className="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous="true" uk-slideshow-item="previous"></button>
            <button className="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next="true" uk-slideshow-item="next"></button>
          </div>
        </div>
      </div>

      <div id="full-review" className="uk-flex-top review-modal" uk-modal="true">
        <div className="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
          <button className="uk-modal-close-default" type="button" uk-close="true"></button>
          <img src={rating} alt="Villaggio Grille 5 star review" className="icon" />
          <p className="auth">Alex Whitaker</p>
          <hr />
          <p>It was our last night in Orange Beach, Alabama. We had paddle boarded, swam, and walked the beach about as much as we could stand that day. We were beat, but we wanted one last “hoorah” before packing up the van the next morning, and we had been meaning to check out the wharf while in town, so we landed on going to Villaggio Grille.</p>

          <p>As far as restaurants go, our experience in Orange Beach had been kind of hit or miss until then. So our expectations were not very high. But the restaurant was very busy that night, so we figured that was a pretty good sign. Neither of us expected what was actually in store for us.</p>

          <p>Our server, Irena, was very kind and promptly refilled our drinks as needed and explained the menu and specials in detail.
          We started with the Oyster Trio - nine baked oysters including three of each of the following: Prosciutto Rockefeller, Gorgonzola & Shallot, and Manchego & Jalapeno.
          The Prosciutto Rockefeller and the Gorgonzola & Shallot both had intense umami flavors and were creamy, not slimy as is often the case in uncooked oysters. The shallots practically melted in my mouth. The Manchego & Jalapeno offered a brighter punch with a not-too-overwhelming heat from the jalapeno.</p>

          <p>Both of us ordered the Seafood Pasta. It included: shrimp, scallops, & crab salad, and was served over fettuccini alfredo. We are big fans of alfredo, so it was a no-brainer. We are now also big fans of Villaggio Grille.</p>

          <p>Each piece of shrimp, scallop and crab were cooked to perfection, not under or overdone in the slightest. And though not listed on the menu, the fresh basil in the sauce worked wonderfully in concert with the other flavors, bringing a light refreshment to match the heavier richness of the alfredo.
          One of the most important things I noticed came towards the end of the meal. I could not see any excess oil pooling at the bottom of my plate. It usually is most noticeable when the food cools off a bit and the oil begins to separate from the cream. This often happens when the chef adds too much oil to the pan on the front end. It was impressive to see the lack of oil and told me that Villaggio Grille hires quality chefs.</p>
          
          <p>About halfway through the meal my wife said, “This is one of the better seafood pastas I've ever had.”
          I could not have disagreed with her more. It was the best. Period. I dare other restaurants to do better.</p>
        </div>
      </div>

      <div id="togoOptions" className="family-meals-full">
        <div className="insideNrw">
          <h1 class="h1">
            Order for delivery! 
            {/* <br/><PhoneLink /> */}
          </h1>

          <div className="deliverySec">
            <div className="clearfix"></div><hr className="top"/>
            <div className="dsInner">
              <div className="deliveryItem tall tteat">
                <a href={tteatLink} target="_blank" rel="noopener noreferrer" className="logoLink">
                  <img src={togoEat} alt="Time to Eat delivery logo and link" className="fw" />
                </a>
              </div>
              <div className="deliveryItem dash dashText">
                <a href={dashLink} target="_blank" rel="noopener noreferrer" className="logoLink">
                  DOORDASH
                </a>
              </div>
            </div>

            <div className="clearfix"></div><hr className="last-ds" />
          </div>

          <div id="family-meals">
            <h2>Takeout Family Meals</h2>
            <h3>Feeds 4 People. All Family Meals Served with a House or Caesar Salad, and House Made Focaccia Bread.</h3>

            <div className="item uno">
              <h4>10 Layer Lasagna... $42</h4>
              <p>Beef and Pork Lasagna, Layered with Ricotta Béchamel, House Made Marinara and Mozzarella</p>
            </div>
            <div className="item">
              <h4>Shrimp or Chicken Alfredo... $42</h4>
              <p>Grilled Chicken or Shrimp, House Made Alfredo, Spinach, Fettuccine Noodle</p>
            </div>
            <div className="item">
              <h4>Grilled Salmon... $56</h4>
              <p>Served with Tomato Risotto, Green Beans, and Balsamic Glaze</p>
            </div>
          </div>
        </div>
      </div>

      <div className="page-content">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="intro-title centered">
                <h1>Villaggio Grille</h1>
                <h3 className="sizing"> Italian Fusion has never tasted so good! Our <strong>talented chefs</strong> and <strong>pristine ingredients</strong> create a dining experience so <strong>enjoyable</strong> you won't want it to end!</h3>
              </div>
            </div>
          </div>
        </div>

        <div className="homeLinks">
          <div className="inside">        
            <div className="left">
              <img src={pizza} alt="Villaggio's wood fired pizza" className="fwImg" />
              <img src={pizzaL} alt="Villaggio's wood fired pizza" className="mobImg" />
            </div>

            <div className="right">
              <div className="linkBox menu">
                <h4>Our Menus</h4>
                <p>Just reading our menus will make your mouth water. Sandwiches, pizzas, seafood, or steaks, we know you will leave satisfied!</p>
                <Link to="/daily-menu" className="btn btn-small yellow">View Menus</Link>
              </div>

              <div className="linkBox wine">
                <h4>Wine List</h4>
                <p>We are the first to admit we take our wine seriously! The wide range of our wine menu just confirms it. Enjoy a glass by itself, or pair it with a delicious dish!</p>
                <Link to="/wine-list" className="btn btn-small yellow">View Wine List</Link>
              </div>

              <div className="linkBox cater">
                <h4>Catering</h4>
                <p>We have everything you need to make any event a success. We offer different catering packages, a great staff, and beautiful venues.</p>
                <a href={caterLink} target="_blank" rel="noreferrer" className="btn btn-small yellow">See More</a>
              </div>
            </div>        
          </div>
        </div>
      </div>
      <div className="fullSec nnHide"><div className="kpWrap"><div className="hr hr-png-10"></div></div></div>
    </div>
  )
}
